import { useRef, useEffect } from "react";
import { OrganizationName } from "types";
import { KnownOrganizationNames } from "@madhive/mad-sdk";
import {
  HOSTNAME_TO_FAV_ICON,
  ORGANIZATION_NAME_TO_FAV_ICON
} from "lib/constants/config";
import { HostNamesDefaults } from "lib/constants/organizations";

export const resolveFavicon = (hostname: string, org: OrganizationName) => {
  const orgIcon = ORGANIZATION_NAME_TO_FAV_ICON[org];
  const hostIcon =
    /* @ts-expect-error - (TS Upgrade: 5.7.3) - https://typescript.tv/errors/#ts7053 */
    HOSTNAME_TO_FAV_ICON[hostname];
  const shared = (HostNamesDefaults as string[]).includes(hostname);
  return (
    (shared ? orgIcon || hostIcon : hostIcon || orgIcon) ||
    ORGANIZATION_NAME_TO_FAV_ICON[KnownOrganizationNames.MADHIVE_DEFAULT]
  );
};

export const useFavicon = (org: OrganizationName) => {
  const refToFavIconLink = useRef<HTMLLinkElement | null>(null);

  useEffect(() => {
    const { hostname } = window.location;
    const favIconPublicURL = resolveFavicon(hostname, org);

    if (refToFavIconLink.current) {
      document.head.removeChild(refToFavIconLink.current);
    }

    const favIconLink = document.createElement("link");
    favIconLink.rel = "shortcut icon";
    favIconLink.href = favIconPublicURL;
    document.head.appendChild(favIconLink);
    refToFavIconLink.current = favIconLink;
  }, [org]);
};
